export enum Features {
    Cooling = 3799,
    HealthClubFitness = 193,
    LaundryFacilities = 194,
    Parking = 192,
    Pool = 196,
    Security = 3798,
    Storage = 197,
    Wheelchair = 3841,
    Elevator = 3840
}